// Dev-only Plate editor performance instrumentation. Removable — no prod
// behavior depends on it.
//
// How to enable (dev builds only):
//   window.__PLATE_PERF__ = true            // or
//   localStorage.setItem('PLATE_PERF', '1') // then reload
//
// What you get:
//   window.__plateRenderCounts              — cumulative render counts per tag
//                                             (always collected in dev, even
//                                             when the flag is off — near-zero
//                                             cost, one map increment)
//   performance.getEntriesByType('mark')    — one `plate-op:<type>` mark per
//                                             editor operation (flag-gated)
//   console '[plate-perf]' lines            — PlateContent commits > 8ms from
//                                             the React.Profiler (flag-gated)
//
// What to expect: with a table mounted, a keystroke OUTSIDE the table used to
// bump `table-cell` by the number of mounted cells per editor change; after
// the re-render fixes it should not grow at all. Drag-selecting text used to
// grow `floating-toolbar` per mousemove; now it grows once per settled
// position (mouseup).

export function isPlatePerfEnabled(): boolean {
    if (process.env.NODE_ENV === 'production') return false;
    try {
        return (window as any).__PLATE_PERF__ === true || window.localStorage.getItem('PLATE_PERF') === '1';
    } catch {
        return false;
    }
}

export function countRender(tag: string): void {
    if (process.env.NODE_ENV === 'production') return;
    const w = window as any;
    if (!w.__plateRenderCounts) w.__plateRenderCounts = {};
    w.__plateRenderCounts[tag] = (w.__plateRenderCounts[tag] ?? 0) + 1;
}

export function markOp(type: string): void {
    if (!isPlatePerfEnabled()) return;
    try {
        performance.mark(`plate-op:${type}`);
    } catch {
        /* performance API unavailable */
    }
}
